module.exports = __webpack_public_path__ + "static/media/ogp-campaign-2019fall.41c668bd.png";